import { Component, OnInit } from "@angular/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-lottieplayer",
    templateUrl: "./lottieplayer.component.html",
    styleUrls: ["./lottieplayer.component.scss"],
    standalone: true,
    imports: [IonicModule, LottieComponent],
})
export class LottieplayerComponent implements OnInit {
  onLoopCompleteCalledTimes = 0;
  constructor() { 
     // do nothing.
  }
  options: AnimationOptions = {
    path: "/assets/test_anim_002_pretty.json",
  };

  animationCreated(animationItem: AnimationItem) {
  }

  // onLoopComplete() {
  //   this.NgZone.run(() => {
  //     setTimeout(() => {


  //       // this.router.navigateByUrl("/mainTabs/tabs/syndicate");
  //       this.location.back()
  //     }, 7000);
  //   });
  // }

  ngOnInit() { }
}
